import { List } from 'antd';
import { theme } from 'configs/styled';
import { useIsWebView } from 'hooks/useIsWebView';
import React from 'react';
import { IMenuItem } from '../../../../../services/driverPortal/main/MainService.interface';
import MenuItem from './Item';

interface IMenuProps {
  menu: IMenuItem[];
}

function buildWebViewMenuConfigs(menuConfigs: IMenuItem[]) {
  const menuConfigsExcludeOnlineTraining = menuConfigs.filter(
    menu => menu.code !== 'onlineTraining',
  );
  const _menuConfigs = menuConfigsExcludeOnlineTraining.map(menu => {
    if (menu.code === 'identity' || menu.code === 'driverLicense') {
      return {
        ...menu,
        description: 'หากต้องการแก้ใขเอกสาร กรุณาติดต่อ 02-826-7995',
        disabled: true,
      };
    } else {
      return menu;
    }
  });
  return _menuConfigs;
}

function getMenuConfigs(isWebView: boolean, menu: IMenuItem[]) {
  if (isWebView) return buildWebViewMenuConfigs(menu);
  return menu;
}

const MenuList: React.FC<IMenuProps> = props => {
  const { menu } = props;
  const isWebView = useIsWebView();
  const menuConfigs = getMenuConfigs(isWebView, menu);

  return (
    <div
      style={{
        marginTop: theme.spacing.lg,
        marginBottom: theme.spacing.lg,
      }}
    >
      <List
        style={{
          background: theme.palettes.white,
        }}
        itemLayout="horizontal"
        size="large"
        dataSource={menuConfigs}
        renderItem={item => <MenuItem item={item} />}
      />
    </div>
  );
};

export default MenuList;
